import { useRumPage } from '@adv-frontend/rum-kit';
import { useLocation } from '@direct-frontend/modules-router';
import { getRumId } from '../utils';

/** Устанавливает имя текущей страницы в RUM. Для регистрации SPA-навигации используйте createRumHistory. */
export const Rum = ({ pageName }: { pageName?: string }) => {
    const location = useLocation();
    const pathname = getRumId(location.pathname);

    useRumPage({ pageName: pageName ?? pathname });

    return null;
};
